import FinanceCalculator from 'components/shared/FinanceCalculator';
import TrustpilotBar from 'components/shared/TrustpilotBar';
import { useMemo } from 'react';
import { useEnquiryContext } from '../context';
import { COPY } from './constants';

const EnquiryComplete: React.FunctionComponent = function () {
  const { isLoading, infoWorkTypes, workType, tradingName } =
    useEnquiryContext();

  const body = useMemo(() => {
    if (tradingName === 'your tradesperson') return COPY.body;
    return `Someone from ${tradingName} will be in touch with you soon. ${COPY.body}`;
  }, [tradingName]);

  return (
    <div className="flex flex-col w-full mb-auto pt-3">
      <h1 className="text-20-24-em md:text-24-28-em mb-4 text-left">
        {COPY.header}
      </h1>
      <h3 className="text-14-22 md:text-16-24 mb-6">{body}</h3>
      <FinanceCalculator
        infoWorkTypes={infoWorkTypes}
        workType={workType}
        isLoading={isLoading}
      />
      <TrustpilotBar wrapperClassName="my-6" />
    </div>
  );
};

export default EnquiryComplete;
